import { useEffect, useState } from 'react';
import { getObraByFeedID } from '../api/obras.api';
import { getObraTimeZone } from '../../videoEditor/utils/obraTimeZone';

// IANA zone of the camera's parent obra, or null while loading / when unknown (callers fail open to the browser zone).
export const useObraTimeZone = (feedID) => {
  const [timeZone, setTimeZone] = useState(null);
  useEffect(() => {
    setTimeZone(null);
    if (!feedID) return undefined;
    let cancelled = false;
    getObraByFeedID(feedID)
      .then((obra) => {
        if (!cancelled) setTimeZone(getObraTimeZone(obra));
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [feedID]);
  return timeZone;
};
